import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=32f84a50&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=32f84a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f84a50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f84a50')) {
      api.createRecord('32f84a50', component.options)
    } else {
      api.reload('32f84a50', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=32f84a50&scoped=true&", function () {
      api.rerender('32f84a50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25NPdww4xu75f/JS/teamMember.vue"
export default component.exports